import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setUsers,
  addUser,
  updateUser,
  removeUser,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  rolesRequestSuccess,
  rolesRequestStart,
  setRoles,
  rolesRequestFailure,
} from "./companyUserSlice";
import companyUserAPI from "../../services/companyUserAPI";
import userRoleAPI from "../../services/userRoleAPI";

// Fetch all company users
export const fetchCompanyUsers = createAsyncThunk(
  "companyUser/fetchCompanyUsers",
  async (params, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await companyUserAPI.getAllUsers(params);
      dispatch(setUsers(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch company users.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Fetch single company user
export const fetchCompanyUser = createAsyncThunk(
  "companyUser/fetchCompanyUser",
  async (userId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await companyUserAPI.getUser(userId);
      dispatch(setUsers(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch company user.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Add a new company user
// Add a new company user
// Modified createCompanyUser function with better error handling
export const createCompanyUser = createAsyncThunk(
  "companyUser/createCompanyUser",
  async (userData, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await companyUserAPI.createUser(userData);
      // Check if response.data.data exists before using it
      if (response.data && response.data.data) {
        dispatch(addUser(response.data.data));
      } else if (response.data) {
        // If data is directly in response.data without nested data property
        dispatch(addUser(response.data));
      }
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      console.error("Create user error:", error);
      const errorMessage =
        error.response?.data?.message || "Failed to create company user.";
      dispatch(apiRequestFailure(errorMessage));
      throw error; // Re-throw the original error for better debugging
    }
  }
);
// Update a company user
export const updateCompanyUser = createAsyncThunk(
  "companyUser/updateCompanyUser",
  async ({ userId, userData }, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await companyUserAPI.updateUser(userId, userData);
      dispatch(updateUser(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update company user.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Delete a company user
export const deleteCompanyUser = createAsyncThunk(
  "companyUser/deleteCompanyUser",
  async (userId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      await companyUserAPI.deleteUser(userId);
      dispatch(removeUser(userId));
      dispatch(apiRequestSuccess());
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete company user.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const fetchUserRoles = createAsyncThunk(
  "companyUser/fetchUserRoles",
  async (_, { dispatch }) => {
    dispatch(rolesRequestStart());
    try {
      const response = await userRoleAPI.getAllRoles();
      dispatch(setRoles(response.data.data || []));
      dispatch(rolesRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch user roles.";
      dispatch(rolesRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
